import React from 'react';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { ReactComponent as UsersIcon } from "../assets/img/user/Users.svg";
import CreateIcon from '@mui/icons-material/Create';
import { COLORS } from '../utils/constants';
import { useCustomAuth } from '../contexts/AuthContext';

const Sidebar = ({ resetPath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {userData, isAdminMode} = useCustomAuth();
  const isAdmin = userData?.roles.includes("ADMIN") || userData?.roles.includes("ROOT") || false

  return (
    <Box
      sx={{
        width: '200px',
        height: '100vh',
        backgroundColor: (isAdmin && isAdminMode) ? COLORS.SIDEBAR_ADMIN : COLORS.SIDEBAR_USER,
        color: 'white',
        position: 'fixed',
        left: 0,
        top: 0,
      }}
    >
      <List>
        <ListItemButton
          onClick={() => navigate('/tutorial')}
          sx={{ 
            py: 2,
            cursor: 'pointer',
            backgroundColor: location.pathname === '/tutorial' ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
        >
          <ListItemIcon>
            <MenuBookIcon sx={{ color: 'white' }} />
          </ListItemIcon>
          <ListItemText 
            primary={
              <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                Tutorial
              </Typography>
            } 
          />
        </ListItemButton>

        <ListItemButton
          onClick={() => {
            if (resetPath) resetPath();
            navigate('/');
          }}
          sx={{ 
            py: 2,
            cursor: 'pointer',
            backgroundColor: location.pathname === '/' ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
        >
          <ListItemIcon>
            <CreateIcon sx={{ color: 'white' }} />
          </ListItemIcon>
          <ListItemText 
            primary={
              <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                Annotation
              </Typography>
            } 
          />
        </ListItemButton>

        {isAdmin && isAdminMode && <ListItemButton 
          onClick={() => navigate('/users')}
          sx={{ 
            py: 2,
            cursor: 'pointer',
            backgroundColor: location.pathname === '/users' ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
        >
          <ListItemIcon>
            <UsersIcon />
          </ListItemIcon>
          <ListItemText 
            primary={
              <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                Users
              </Typography>
            } 
          />
        </ListItemButton>}
      </List>
    </Box>
  );
};

export default Sidebar; 